import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCourt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCourt"><Path d="M21 4.76562L12 1.95312L3 4.76562V10.0008H5L5 18H7L7 10.0008H9L9 18H11L11 10.0008H13L13 18H15L15 10.0008H17L17 18H19L19 10.0008H21V4.76562Z" fill="currentColor"/><Path d="M21 19V21H3V19H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCourt;
